import React from "react";

const TodoInput = props => {
  const { loading, type, placeholder, name, register, error, disabled, notErrorMessage, className } = props;

  const isError = error ? "todo__input--error" : "";

  const isLoading = loading ? "todo__input--loading" : "";

  return (
    <div className={`w-100 ${className}`.trim()}>
      <input type={type} className={`todo__input ${isError} ${isLoading}`.trim()} placeholder={placeholder} disabled={disabled} {...register(name)} />
      {error && !notErrorMessage && <div className="mt-5 text-error-light">{error.message}</div>}
    </div>
  );
}

TodoInput.defaultProps = {
  notErrorMessage: false,
  disabled: false
}

export default TodoInput;